// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3DqnI","content":"LoadingAlert_content__28-KV"};